import styled from '@emotion/styled'

import { palette, spacing } from 'main/ui'

export const Container = styled.div`
  background: ${palette.whiteDove};
  border-radius: 4px;
  padding: ${spacing.minorScale(3)}px;
  display: flex;
`

export const IconContainer = styled.div`
  color: ${palette.goldenrod2};
  margin-right: ${spacing.majorScale(2)}px;
  width: ${spacing.majorScale(3)}px;
  min-width: ${spacing.majorScale(3)}px;
`
